// @ts-nocheck c85819b8
import addPanelDataConsts from '#packages/addPanelDataConsts';

export default {
  type: addPanelDataConsts.SECTIONS_TYPES.THEME,
  hide: false,
  title: 'add_section_label_theme_button',
  subNavigationTitle: 'add_section_label_theme_button',
  presetTitle: 'add_section_label_theme_button',
  tooltipTitle: 'add_section_label_theme_button',
  automationId: 'add-panel-section-buttonThemeSection',
  subNavigationHide: false,
  showSectionHeader: true,
  additionalBehaviours: {
    labelMode: addPanelDataConsts.LABEL_BEHAVIOUR.NONE,
    infoIcon: addPanelDataConsts.INFO_ICON_BEHAVIOUR.NONE,
    iconEnabledForComps: [],
  },
  props: {
    compTypes: ['wysiwyg.viewer.components.SiteButton'],
    verticalMargin: 30,
    horizontalMargin: 20,
    maxFontSize: 22,
    scaleProportion: {
      x: 1,
      y: 1,
    },
  },
  help: {
    hide: false,
    text: 'add_section_info_text_theme_general',
  },
};
